"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("./store");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return store_1.default; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "getKeyInStorage", { enumerable: true, get: function () { return utils_1.getKeyInStorage; } });
Object.defineProperty(exports, "hasKeyInStorage", { enumerable: true, get: function () { return utils_1.hasKeyInStorage; } });
Object.defineProperty(exports, "setKeyInStorage", { enumerable: true, get: function () { return utils_1.setKeyInStorage; } });
Object.defineProperty(exports, "clearItemsInStorage", { enumerable: true, get: function () { return utils_1.clearItemsInStorage; } });
